import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path';

import "./bill.css";
const AdminstrativeApproval = () => {
    const { id } = useParams()
    console.log("id", id);
    const Navigate = useNavigate();
    const context = useContext(AdminContext);
    const { GetAdminApprovalInwardsList, AdministrativeApproveOperation } = context
    const [technicalInwards, setTechnicalInwards] = useState([])

    const getTechnicalInwardsApprove = async () => {
        let data = await GetAdminApprovalInwardsList('ID', id)
        console.log("data", data);

        setTechnicalInwards(data[0])
        // setFilteredBills(data);
    }
    useEffect(() => {
        getTechnicalInwardsApprove()
    }, [])

    const ApproveSanction = async () => {
        const confirmed = window.confirm("Are you sure?");
        if (!confirmed) return;
        try {
            let data = await AdministrativeApproveOperation(id);
            console.log("data");

            if (data?.message) {
                alert(data?.message)
                Navigate('/AdminDashboard/AdministrativeApprovalInwards')
            } else {
                alert("Administrative Approved Failed")
                Navigate('/AdminDashboard/AdministrativeApprovalInwards')
            }
        } catch (error) {
            console.error("Approval error:", error);
            alert("An error occurred during approval.");
        }

    }

    return (

        <>

            {
                technicalInwards &&
                <div style={{ display: "grid", justifyContent: "center", marginTop: "5rem", marginBottom: "5rem" }}>
                    {/* <h3>TechnicalSanctionApprove</h3> */}
                    <div className="bill-container" id="container" >
                        <div className="bill-header">
                            {/* <div>
              <img src="/logo1.png" alt="..." style={{ width: "100px" }} />
            </div> */}
                            <div style={{ color: "red" }} className="municipal-council">
                                <h4>Single Unified Portal</h4>
                            </div>
                            <div className="form">(Rural Development Department)</div>
                            <div className="bill-title">Zila Parishad</div>
                        </div>

                        <div className="estate-details">
                            {/* <div className="estate-code"> */}
                            User Name: {technicalInwards?.GovernmentApprovalNumber}

                            {/* </div> */}
                            <div className="ward">Date Time: {technicalInwards?.created_At}</div>
                        </div>

                        <div style={{ border: "1px black solid", padding: "5px", backgroundColor: "#e9f8f1" }}>
                            <div className="innerheader" style={{ display: "flex", justifyContent: "center" }}>
                                <div>Administrative Approval Details</div>
                            </div>

                        </div>
                        <div style={{ border: "1px black solid", display: "hidden" }}>
                            {/* <div className="tax-details-title" style={{ textAlign: "center" }}>Details of Taxes</div> */}
                            <div className="tax-table" >
                                <table className="table table-striped tax-table-data">
                                    <thead className="table-dark">

                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "25%" }}><b>Adminstrative Approval RDD UID</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards?.AdminApprovalID}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}><b>Adminstrative Approval Number</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards?.GovernmentApprovalNumber}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}><b>HeadCode</b> </td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.HeadCode}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}><b>Approval Year</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.AdminApprovalYear}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}><b>GR UID</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.GRUID}</span></td>
                                        </tr>
                                        {/* <tr>
                                            <td style={{ width: "25%" }}><b>Zila Parishad</b> </td>
                                            <td align="center" style={{ width: "25%" }}> <span id="lbl_genTax2">{technicalInwards.GramPanchayat}</span> </td>
                                        </tr> */}
                                        {/* <tr>
                                            <td style={{ width: "25%" }}> <b>Taluka</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.Taluka}</span></td>
                                        </tr> */}
                                        {/* <tr>
                                            <td style={{ width: "25%" }}> <b>Constituency Name</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.ConstituencyName}</span></td>
                                        </tr> */}
                                        {/* <tr>
                                            <td style={{ width: "25%" }}> <b>Gram Panchayat</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.GramPanchayat}</span></td>
                                        </tr> */}
                                        {/* <tr>
                                            <td style={{ width: "25%" }}> <b>Village</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.Village}</span></td>
                                        </tr> */}
                                        {/* <tr>
                                            <td style={{ width: "25%" }}> <b>Work Name</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.WorkName}</span></td>
                                        </tr> */}
                                        {/* <tr>
                                            <td style={{ width: "25%" }}> <b>Technical Sanction No.</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.TechnicalSanctionNo}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}> <b>Type of Work</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.TypeofWork}</span></td>
                                        </tr> */}
                                        <tr>
                                            <td style={{ width: "25%" }}> <b>Approval Amount</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.Amount}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}> <b>Administrative Approval File Copy</b></td>
                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">
                                                <a href={`${apiurl}/ProposalFile/${technicalInwards.AdminApprovalCopy}`} target='_blank' />{technicalInwards.AdminApprovalCopy}
                                            </span></td>
                                        </tr>
                                        {/* <tr>
                  <td style={{ width: "25%"}}> <b>GR Signed Copy</b></td>
                  <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.Taluka}</span></td>
                </tr> */}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* <div style={{ border: "1px black solid", padding: "5px", backgroundColor: "#e9f8f1" }}>
          <div className="innerheader" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ color: "green" }}>Click Here to Tag GIS Mapping</div>
          </div>
        </div> */}
                        <div style={{ border: "1px black solid", padding: "5px", backgroundColor: "#e9f8f1" }}>
                            <div className="innerheader" style={{ display: "flex", justifyContent: "center" }}>
                                <div>Declaration</div>
                            </div>
                            <div className="note">
                                I hereby declare that the information given above and in the enclosed documents is true to the best of my knowledge
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <div>
                                <button className='btn btn-success' onClick={() => ApproveSanction()}>Approve</button>
                                {/* <button className='btn btn-danger mx-3'>Reject</button> */}
                            </div>
                        </div>
                    </div>

                </div>
            }

        </>
    )
}

export default AdminstrativeApproval;
